// src/components/CmsModal/CmsModal.tsx
import React from "react";
import "./Cmsmodal.css";

interface CmsModalProps {
  title: string;
  content: string;
  onClose: () => void;
}

const CmsModal: React.FC<CmsModalProps> = ({ title, content, onClose }) => {
  return (
    <div className="cms-modal-overlay" onClick={onClose}>
      <div className="cms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cms-modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="modal-close" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="cms-modal-content" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

export default CmsModal;